// Shared helpers for ordering client records alphabetically.
//
// Rule (per Richard, May 2026): sort by company if the record has one,
// otherwise by "Last, First" extracted from the full-name field. Companies
// and individuals interleave so the alphabet is one continuous list.

/** Build the alphabetical sort key for a client-shaped record. */
export function clientSortKey(rec) {
  const company = (rec?.company || '').trim();
  if (company) return company.toLowerCase();
  const name = (rec?.name || '').trim();
  if (!name) return '\uFFFF'; // park empty rows at the very end
  const parts = name.split(/\s+/);
  if (parts.length === 1) return parts[0].toLowerCase();
  const last = parts[parts.length - 1];
  const first = parts.slice(0, -1).join(' ');
  return `${last}, ${first}`.toLowerCase();
}

/** Display string ("Acme Roofing" or "Smith, John") for a client. */
export function clientLastFirst(rec) {
  const company = (rec?.company || '').trim();
  if (company) return company;
  const name = (rec?.name || '').trim();
  if (!name) return '';
  const parts = name.split(/\s+/);
  if (parts.length === 1) return parts[0];
  const last = parts[parts.length - 1];
  const first = parts.slice(0, -1).join(' ');
  return `${last}, ${first}`;
}

/** Stable alphabetical sort using clientSortKey. */
export function sortClientsAlpha(list) {
  return [...(list || [])].sort((a, b) =>
    clientSortKey(a).localeCompare(clientSortKey(b))
  );
}
